import './hartfordyardgoats/style';
import FormStructure from './hartfordyardgoats/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/includes.js